<script>
    import Edit from '@/assets/starface_icons_png/16/orange/edit_16.png';
    import Delete from '@/assets/starface_icons_png/24/orange/delete_24@2x.png';
    import Add from '@/assets/starface_icons_png/16/white/add_16.png';

    export default {
        name: 'ButtonIconLeft',
        props: {
            buttonTitle: {
                type: String,
                required: true,
            },
            src: {
                type: String,
                required: true,
            },
            cssClass: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                imageSource: Edit,
            };
        },
        created() {
            switch (this.src) {
                case 'add':
                    this.imageSource = Add;
                    break;
                case 'edit':
                    this.imageSource = Edit;
                    break;
                case 'delete':
                    this.imageSource = Delete;
                    break;
            }
        },
    };
</script>
<template>
    <button :class="cssClass" @click="$emit('onClick')">
        <img :src="imageSource" alt="Button Icon"> {{buttonTitle}}
    </button>
</template>

<style lang="scss" scoped>
    @import '../../assets/scss/buttons.scss';

    img {
        height: 16px;
        padding-right: 8px;
    }
</style>
